import { render, staticRenderFns } from "./navStepList.vue?vue&type=template&id=85b4b970&scoped=true&"
import script from "./navStepList.vue?vue&type=script&lang=js&"
export * from "./navStepList.vue?vue&type=script&lang=js&"
import style0 from "./navStepList.vue?vue&type=style&index=0&id=85b4b970&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b4b970",
  null
  
)

export default component.exports